import { render } from "./EmarsysRecos.vue?vue&type=template&id=10dcc86d&scoped=true&ts=true"
import script from "./EmarsysRecos.vue?vue&type=script&lang=ts"
export * from "./EmarsysRecos.vue?vue&type=script&lang=ts"

import "./EmarsysRecos.vue?vue&type=style&index=0&id=10dcc86d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dcc86d"]])

export default __exports__